import { queryOptions, useQuery } from '@tanstack/react-query'
import type { InferRequestType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

export type UseFindAttachmentsArgs = InferRequestType<
  typeof apiClient.attachments.search.$post
>['json']

export const findAttachmentsQueryOptions = (args?: UseFindAttachmentsArgs) =>
  queryOptions({
    queryKey: ['attachments', args],
    queryFn: () =>
      apiClient.attachments.search
        .$post({ json: args })
        .then((r) => formatClientResponse(r)),
  })

export const useFindAttachments = (
  args?: UseFindAttachmentsArgs,
  options?: Partial<ReturnType<typeof findAttachmentsQueryOptions>>
) =>
  useQuery({
    ...findAttachmentsQueryOptions(args),
    ...options,
  })
